module.exports = __webpack_public_path__ + "assets/img/register_date-b86d84a2.png";